/**
 * Екран „Вход“ (Раздел 8).
 */

import { useState } from 'react';
import {
  Alert,
  Anchor,
  Button,
  Center,
  Paper,
  PasswordInput,
  Stack,
  TextInput,
  Title,
} from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { ApiError } from '../api/client';

export function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event: React.FormEvent): Promise<void> => {
    event.preventDefault();
    setError(null);
    setIsSubmitting(true);

    try {
      await login(email, password);
    } catch (caught) {
      setError(caught instanceof ApiError ? caught.message : 'Входът не беше успешен');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Center h="100vh">
      <Paper withBorder shadow="sm" p="xl" w={400}>
        <form onSubmit={(event) => void handleSubmit(event)}>
          <Stack>
            <Title order={3}>Анализ на разговори</Title>

            {error && (
              <Alert color="red" title="Неуспешен вход">
                {error}
              </Alert>
            )}

            <TextInput
              label="Имейл"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.currentTarget.value)}
              required
              autoFocus
            />
            <PasswordInput
              label="Парола"
              value={password}
              onChange={(event) => setPassword(event.currentTarget.value)}
              required
            />
            <Button type="submit" loading={isSubmitting} fullWidth>
              Вход
            </Button>
            <Anchor component="button" type="button" size="sm" ta="center" onClick={() => navigate('/forgot-password')}>
              Забравена парола
            </Anchor>
          </Stack>
        </form>
      </Paper>
    </Center>
  );
}
